import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "SearchHeading" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!
  const _component_ExpandableContent = _resolveComponent("ExpandableContent")!
  const _component_Skeleton = _resolveComponent("Skeleton")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['SearchHeader', { 'has-static-content': !_ctx.staticContentEmpty }])
  }, [
    _createVNode(_component_Breadcrumbs),
    _createElementVNode("div", {
      class: _normalizeClass(['ExpandableContentSection', { 'is-expanded': _ctx.expanded && !_ctx.staticContentEmpty }])
    }, [
      _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.title), 1 /* TEXT */),
      (!_ctx.staticContentEmpty)
        ? (_openBlock(), _createBlock(_component_ExpandableContent, {
            key: 0,
            expanded: _ctx.expanded,
            onToggleExpand: _ctx.toggleExpand
          }, null, 8 /* PROPS */, ["expanded", "onToggleExpand"]))
        : _createCommentVNode("v-if", true)
    ], 2 /* CLASS */),
    _createElementVNode("div", {
      class: _normalizeClass(['NavigationButtons', { 'has-static-content': !_ctx.staticContentEmpty, 'is-static-content-expanded': _ctx.expanded && !_ctx.staticContentEmpty }])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleSwitchTabs, (tab) => {
        return (_openBlock(), _createBlock(_component_Skeleton, {
          active: tab.loading,
          custom: { customWidth: '100px', customHeight: '1.5rem' },
          background: "Dark",
          key: tab.type
        }, {
          default: _withCtx(() => [
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["SearchNavigationButton", { Active: tab.type === _ctx.searchTypeStudy }]),
              onClick: ($event: any) => (_ctx.switchToTab(tab.type))
            }, [
              (!tab.loading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(tab.label), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ], 10 /* CLASS, PROPS */, _hoisted_2)
          ]),
          _: 2 /* DYNAMIC */
        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["active"]))
      }), 128 /* KEYED_FRAGMENT */))
    ], 2 /* CLASS */)
  ], 2 /* CLASS */))
}